var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"link",attrs:{"to":{ name: 'Home' }}},[_c('i',{staticClass:"bx bx-exit"}),_vm._v(" Salir ")])}
var staticRenderFns = []

export { render, staticRenderFns }